import type { RealtimeEvent } from "@shared/types/foyer";

type Listener = (evt: RealtimeEvent) => void;

const listeners = new Set<Listener>();

export const eventBus = {
  emit(evt: RealtimeEvent): void {
    listeners.forEach((l) => l(evt));
  },
  on(listener: Listener): () => void {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },
  clear(): void {
    listeners.clear();
  },
};

declare global {
  interface Window {
    foyerEventBus?: typeof eventBus;
  }
}

if (typeof window !== "undefined") {
  window.foyerEventBus = eventBus;
}
